import React from "react";
import { Steps } from "antd";
import "./WorkflowStepper.css";

const WorkflowStepper = ({
  items = [],
  currentStep = 0,
  onChange,
  className = "",
}) => {
  if (!Array.isArray(items) || items.length === 0) {
    return null;
  }

  return (
    <div className={`workflow-stepper ${className}`}>
      <Steps
        current={currentStep}
        items={items}
        onChange={onChange}
        responsive
        
      />
    </div>
  );
};

export default WorkflowStepper;
